/**
 * 主题防闪烁初始化
 * 在 main.js 最顶部 import，确保 Vue 挂载前已应用主题
 */
(function () {
  try {
    var t = localStorage.getItem('mpplus-theme') || 'dark'
    document.documentElement.dataset.theme = t
  } catch (e) { /* 忽略 SSR/测试环境 */ }
})()
